/**
 *
 * @param {object} event
 * @param {boolean} isFormDirty
 * @param {function} navigate
 * @param {string} route
 * @returns
 */
export const navigateWithAlert = ({ event, isFormDirty, navigate, route }) => {
  event.preventDefault(); // prevents the "Form submission canceled because the form is not connected" warning
  if (!isFormDirty) {
    return navigate(route);
  }
  const message = "Are you sure? This form has unsaved changes.";
  if (window.confirm(message)) {
    return navigate(route);
  }
};
